import { Navigate, Route, Routes } from 'react-router-dom'

import { Layout } from '@/components/Layout'
import { LoginPage } from '@/pages/Login'
import { DashboardPage } from '@/pages/Dashboard'
import { FinancierbaarPage } from '@/pages/Financierbaar'
import { InvoerVoorraadPage } from '@/pages/InvoerVoorraad'
import { InvoerMateriaalPage } from '@/pages/InvoerMateriaal'
import { BeheerPage } from '@/pages/Beheer'
import { ProtectedRoute } from '@/components/ProtectedRoute'

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard"          element={<DashboardPage />} />
        <Route path="/financierbaar"      element={<FinancierbaarPage />} />
        <Route path="/invoer/voorraad"    element={<InvoerVoorraadPage />} />
        <Route path="/invoer/materiaal"   element={<InvoerMateriaalPage />} />
        <Route path="/beheer"             element={<BeheerPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
